import { makeRequest, ApiResponseType } from "../../../common/helpers/api.helpers";
import { createDebounce } from "../../../common/helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

type ApproveRenterProps = {
  renterId: string;
};

export type AsaasPayment = {
  object: string;
  id: string;
  dateCreated: string;
  customer: string;
  paymentLink: string | null;
  installment: string;
  dueDate: string;
  value: number;
  netValue: number;
  billingType: string;
  canBePaidAfterDueDate: boolean;
  pixTransaction: string | null;
  status: string;
  description: string;
  externalReference: string;
  originalValue: number | null;
  interestValue: number | null;
  originalDueDate: string;
  paymentDate: string | null;
  clientPaymentDate: string | null;
  installmentNumber: number;
  transactionReceiptUrl: string | null;
  nossoNumero: string;
  invoiceUrl: string;
  bankSlipUrl: string;
  invoiceNumber: string;
  discount: {
    value: number;
    dueDateLimitDays: number;
  };
  fine: {
    value: number;
  };
  interest: {
    value: number;
  };
  deleted: boolean;
  postalService: boolean;
  anticipated: boolean;
  anticipable: boolean;
  refunds: unknown | null; // You can specify a more specific type for refunds if needed
  nextDueDate: Date;
};

export async function bindVheicleVelotrack(data: ApproveRenterProps) {
  const url = `${API_URL}/integration/velotrack`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebounced(url, options) as Promise<ApiResponseType<unknown>>;

  return result;
}

export async function sendDataIleva(data: { vehicleId: string}) {
  const url = `${API_URL}/integration/ileva`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebounced(url, options) as Promise<ApiResponseType<unknown>>;

  return result;
}

export type FormCaucao = {
  renterId: string
  valueDepositInstallments: number
  methodPayment: string
  installmentOption: string
  deposit: number
  creditDeposit: number
  valueDepositCredit: number
  easyDeposit: boolean
  easyDepositDate: Date | null // ISO string or null
  easyDepositEntryOption: string
  easyDepositEntryValue: number
  easyDepositInstallments: number
  easyDepositRemainingValue: number
}

export async function createAssasSubscription(data: Partial<FormCaucao>) {
  const url = `${API_URL}/integration/deposit`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebounced(url, options) as Promise<ApiResponseType<unknown>>;

  return result;
}

export type installmentTrafficFine = {
  description: string;
  installmentOption: string;
  installmentValue: string;
  licensePlate: string;
  nextDueDate: string;
  paymentsIds: string[];
  renterId: string;
  value: number;
  actionSelection: string;
}
export async function createFineAssasSubscription(data: installmentTrafficFine) {
  const url = `${API_URL}/integration/fineSubscription`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  const result = makeRequestDebounced(url, options) as Promise<ApiResponseType<unknown>>;
  return result;
}

export async function getLastAsaasPayment(renterId: string) {
  const url = `${API_URL}/asass/lastPayment/${renterId}`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  const result = makeRequestDebounced(url, options) as Promise<ApiResponseType<AsaasPayment>>;
  return result;
}


export async function createAssasBooking(data: ApproveRenterProps) {
  const url = `${API_URL}/integration/billing`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebounced(url, options) as Promise<ApiResponseType<unknown>>;

  return result;
}

type Addition = {
  label: string;
  value: string;
  key: string;
}

type Period = {
  value: string,
  label: string,
  months: number,
  days?: number,
}

export type ContractProps = {
  renterId: string;
  vehicleId: string;
  period?: Period;
  additions?: Addition[];
  contractType?: string;
}

export async function createContract(data: ContractProps) {
  const url = `${API_URL}/contracts`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebounced(url, options) as Promise<ApiResponseType<unknown>>;

  return result;
}
